export default "__VITE_ASSET__DBzOvltu__"